import React, { useEffect, useState, useRef, useContext } from "react";
import AppContext from "./context";
import TextPlayer from "./TextPlayer";
import VideoPlayer from "./VideoPlayer";

export default function VideoTracker({ video, order }) {
  const { sources, speaker, words, id } = video;
  const { currentPlayingId } = useContext(AppContext);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentWord, setCurrentWord] = useState(0);
  const [remainingTime, setRemainingTime] = useState(null);


  useEffect(() => {
    if(remainingTime === 0.0) {
        setCurrentWord(0);
        setIsPlaying(false);
        console.log({remainingTime});
    }
  }, [remainingTime]);

  useEffect(() => {
    setIsPlaying(id === currentPlayingId.id && currentPlayingId.isPlaying);
  }, [currentPlayingId]);

  const videoElem = (
    <div className="videoCont">
      <VideoPlayer
        setRemainingTime={setRemainingTime}
        id={id}
        sources={sources}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
      />
    </div>
  );

  const speakerElem = (
    <div className="speaker">
      <h1>{speaker.name}</h1>
      <p>{speaker.job}</p>
      <TextPlayer
        currentWord={currentWord}
        setCurrentWord={setCurrentWord}
        words={words}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
      />
      <div className="link cta-container">
        <a href={speaker.fullinterview} className="-arrow">
          {speaker.customlink}
        </a>
      </div>
    </div>
  );

  return order % 2 === 0 ? (
    <div className="VideoText VideoLeft">
      {speakerElem}
      {videoElem}
    </div>
  ) : (
    <div className="VideoText VideoRight">
      {videoElem}
      {speakerElem}
    </div>
  );
}
